"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidCurrencyCode = exports.allCurrencies = exports.getCurrencyByCountryCode = void 0;
const tslib_1 = require("tslib");
const uniq_1 = tslib_1.__importDefault(require("lodash/uniq"));
exports.getCurrencyByCountryCode = {
    USA: "USD",
    AUS: "AUD",
    GBR: "GBP",
    NZL: "NZD",
    HKG: "HKD",
    ISL: "ISK",
    PHL: "PHP",
    DNK: "DKK",
    HUN: "HUF",
    CZE: "CZK",
    ROU: "RON",
    SWE: "SEK",
    IDN: "IDR",
    IND: "INR",
    BRA: "BRL",
    RUS: "RUB",
    HRV: "HRK",
    JPN: "JPY",
    THA: "THB",
    AUT: "EUR",
    BEL: "EUR",
    DEU: "EUR",
    ESP: "EUR",
    EST: "EUR",
    FIN: "EUR",
    FRA: "EUR",
    IRL: "EUR",
    ITA: "EUR",
    LTU: "EUR",
    LVA: "EUR",
    NLD: "EUR",
    SVK: "EUR",
    SVN: "EUR",
    SXM: "EUR",
    MYS: "MYR",
    BGR: "BGN",
    TUR: "TRY",
    CHN: "CNY",
    NOR: "NOK",
    ZAF: "ZAR",
    MEX: "MXN",
    SGP: "SGD",
    ISR: "ILS",
    KOR: "KRW",
    CHE: "CHF",
    POL: "PLN",
    CAN: "CAD",
    ARE: "AED",
    SAU: "SAR",
    EGY: "EGP",
    VNM: "VND",
    ARG: "ARS",
    CHL: "CLP",
    COL: "COP",
    URY: "UYU",
};
exports.allCurrencies = (0, uniq_1.default)(Object.values(exports.getCurrencyByCountryCode));
const isValidCurrencyCode = (currencyCode) => exports.allCurrencies.includes(currencyCode);
exports.isValidCurrencyCode = isValidCurrencyCode;
//# sourceMappingURL=currencies.js.map